module.exports = __webpack_public_path__ + "img/logo-ciphra-white.d431dad0.svg";